import Navigation from '../../../../components/layout/Navigation';
import Footer from '../../../../components/layout/Footer';
import Hero from '../../../../components/ui/Hero';
import Section from '../../../../components/ui/Section';
import FeatureGrid from '../../../../components/ui/FeatureGrid';
import ProcessTimeline from '../../../../components/ui/ProcessTimeline';
import CTA from '../../../../components/ui/CTA';

export default function LogoDesignPage() {
  return (
    <div className="min-h-screen bg-black text-white">
      <Navigation />
      
      <Hero 
        title={<>Your Brand's Story.<br /><span className="bg-gradient-to-r from-orange-400 to-pink-500 bg-clip-text text-transparent">Simplified. Perfected.</span></>}
        description="We design iconic logos that instantly communicate your essence and resonate with your audience."
        bgImage="/assets/professional-logo-design.png"
        primaryBtn={{ text: "Start Project", link: "/contact", icon: "ri-brush-line" }}
        secondaryBtn={{ text: "View Portfolio", link: "/work", icon: "ri-gallery-line" }}
      />

      <Section>
        <FeatureGrid 
          title={<>Beyond Aesthetics: <span className="text-orange-400">A Logo that Defines</span></>}
          subtitle="Effective logo design translates complex brand attributes into a simple, scalable, and memorable graphic mark."
          items={[
            { title: 'Memorable', description: 'Easy to recall and recognize.', icon: 'ri-brain-line', color: 'from-blue-500 to-purple-600' },
            { title: 'Versatile', description: 'Works across all sizes and mediums.', icon: 'ri-smartphone-line', color: 'from-green-500 to-teal-600' },
            { title: 'Timeless', description: 'Endures trends and remains relevant.', icon: 'ri-time-line', color: 'from-orange-500 to-red-600' },
            { title: 'Appropriate', description: 'Reflects your industry and audience.', icon: 'ri-target-line', color: 'from-pink-500 to-purple-600' },
            { title: 'Simple', description: 'Clean and easy to understand.', icon: 'ri-pencil-line', color: 'from-indigo-500 to-blue-600' }
          ]}
        />
      </Section>

      <Section className="bg-gray-900">
        <ProcessTimeline 
          title="From Concept to Iconic Mark"
          subtitle="Our logo design process is collaborative and meticulously crafted to reflect your brand's essence."
          steps={[
            { title: 'Discovery', description: 'Gathering info about your brand values.', icon: 'ri-search-line', color: 'from-blue-500 to-purple-600' },
            { title: 'Research', description: 'Exploring trends and drafting concepts.', icon: 'ri-lightbulb-line', color: 'from-green-500 to-teal-600' },
            { title: 'Presentation', description: 'Presenting concepts for feedback.', icon: 'ri-presentation-line', color: 'from-orange-500 to-red-600' },
            { title: 'Refinement', description: 'Finalizing details based on input.', icon: 'ri-edit-line', color: 'from-pink-500 to-purple-600' },
            { title: 'Delivery', description: 'Providing all file formats and guidelines.', icon: 'ri-file-zip-line', color: 'from-indigo-500 to-blue-600' }
          ]}
        />
      </Section>

      <CTA 
        title={<>Let's Design Your <span className="text-orange-400">Unforgettable Mark</span></>}
        description="Partner with Hash Adz to craft a logo that truly defines your brand and leaves a lasting impression."
        primaryBtn={{ text: "Start Design", link: "/contact" }}
        secondaryBtn={{ text: "Our Portfolio", link: "/work" }}
        stats={[
          { number: '500+', label: 'Logos Designed' },
          { number: '98%', label: 'Satisfaction' },
          { number: '24/7', label: 'Support' }
        ]}
      />

      <Footer />
    </div>
  );
}